var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "main-content" }, [
    _vm.loading
      ? _c("div", { staticClass: "card" }, [
          _c(
            "div",
            { staticClass: "card-header" },
            [
              _c("pulse-loader", {
                staticClass: "text-center",
                attrs: { loading: true, color: _vm.$constants.LOADING_COLOR },
              }),
            ],
            1
          ),
        ])
      : _vm._e(),
    _vm._v(" "),
    !_vm.loading
      ? _c(
          "div",
          _vm._l(_vm.orders, function (orders, senderId) {
            return _c("div", { staticClass: "card" }, [
              _c("div", { staticClass: "card-header" }, [
                _c("h5", [_vm._v(_vm._s(_vm.senders[senderId].name))]),
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "card-body" },
                [
                  _c("CodOrdersList", {
                    ref: `orders_${senderId}`,
                    refInFor: true,
                    attrs: {
                      appointed: true,
                      disableEdit: true,
                      orders: orders,
                    },
                  }),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "card-footer text-right" },
                    [
                      _c("LoadingButton", {
                        attrs: {
                          title: "отметить доставленными",
                          className: "btn btn-outline-success btn-xs",
                          onClick: () =>
                            _vm.updateOrders(senderId, "сloseOrders"),
                          loading: _vm.loadingSenderBtns[senderId],
                          color: _vm.$constants.SUCCESS_COLOR,
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ])
          }),
          0
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }